<template>
  <main :class="classes">

    <!-- Review -->
    <div class="container view-checkout-review__content">
      <div class="col">
        <!-- Cart -->
        <section class="view-checkout-review__cart checkout-cart">
          <div class="checkout-cart__header">
            <h1 class="checkout-cart__title">{{ $t('sayl-oat.table_number', {tableNumber}) }}</h1>
            <h2 class="checkout-cart__subtitle">{{ $t('sayl-oat.checkout_review_cart_subtitle') }}</h2>
          </div>

          <cart />

          <div class="checkout-cart__footer">
            <actions-button
              :href="{name: 'sayl-oat-catalog.catalog'}"
            >{{ $t('sayl-oat.back_button') }}</actions-button>
          </div>
        </section>
      </div>

      <div class="col">
        <!-- Auth -->
        <section class="checkout-card checkout-auth">

          <header class="checkout-card__header">
            <h2 class="checkout-card__title">{{ $t('sayl-oat.checkout_review_about_you') }}</h2>
          </header>

          <form class="checkout-card__body flow">
            <div class="group">
              <forms-input 
                required
                :errors="errors['user']"
                name="given-name"
                autocomplete
                autofocus 
                placeholder="e.g. Luke"
                v-model="vUser.firstname">{{ $t('sayl-oat.checkout_review_firstname') }}</forms-input>
              <forms-input 
                name="family-name"
                autocomplete
                placeholder="e.g. Skywalker"
                v-model="vUser.lastname">{{ $t('sayl-oat.checkout_review_lastname') }}</forms-input>
            </div>

            <div v-if="false" class="group">
              <forms-input
                name="email"
                autocomplete
                :errors="errors['email']"
                placeholder="e.g. luke@skywalker.com"
                type="email"
                v-model="vUser.email">{{ $t('sayl-oat.checkout_review_email') }}</forms-input>
            </div>

            <div class="group">
              <forms-textarea
                :placeholder="$t('sayl-oat.placeholder')"
                v-model="comment"
              >{{ $t('sayl-oat.checkout_review_comment') }}</forms-textarea>  
            </div>
          </form>
        </section>

        <!-- Methods -->
        <section v-if="false" class="checkout-card checkout-methods">
          <header class="checkout-card__header">
            <h2 class="checkout-card__title">{{ $t('sayl-oat.checkout_review_payment_methods_title') }}</h2>
          </header>

          <div class="checkout-card__body">
            <forms-choice 
              :options="methods"
              v-model="payment">
            </forms-choice>
          </div>
        </section>

        <!-- TC -->
        <section class="checkout-card checkout-terms">
          <div class="checkout-card__body flow">
           
            <div class="view-checkout-review__terms" v-html="$t('sayl-oat.checkout_review_terms')"></div>
            <actions-button 
              appearance="primary"
              class="view-checkout-review__cta"
              @click="onConfirm">{{ $t('sayl-oat.checkout_order_label') }}</actions-button>
          </div>
        </section>
      </div>
    </div>

    <!-- Processing -->
    <div v-if="loading" class="view-checkout-review__loading">
      <ui-loader size="l" />
    </div>
  </main>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Cart from '@/components/checkout/cart'

export default {
  name: 'CheckoutReview',

  components: {
    Cart
  },

  data(){
    return {
      errors: {},
      loading: true,
      payment: null,
      vUser: {
        firstname: null,
        lastname: null,
        email: null,
      },
      comment: null
    }
  },

  computed: {
    ...mapState({
      cart: state => state['sayl-oat'].cart,
      paymentMethods: state => state['sayl-oat'].paymentMethods,
      user: state => state['sayl-oat.user'].user,
      tables: state => state['sayl-oat'].tables,
    }),

    classes(){
      return {
        'view-checkout-review__body': true,
        '-is-loading': this.loading
      }
    },

    methods() {
      let ret = [];

      !this.loading && this.paymentMethods.forEach(pm => {
        ret.push({
          label: this.$t(`sayl-oat.payment_methods_${pm.slug}`),
          description: this.$t(`sayl-oat.payment_methods_description_${pm.slug}`),
          value: pm.slug
        });
      });

      this.payment = ret[0];

      return ret;
    },

    tableNumber(){
      let ret = '';
      const t = this.tables.find(t => t.id === this.cart.tableNumber);

      if(t) {
        ret = t.name || ''
      }

      return ret;
    }
  },

  methods: {
    ...mapActions({
      checkout: 'checkout',
      getPaymentMethods: 'getPaymentMethods',
      confirm: 'confirm'
    }),

    onConfirm(){
      this.loading = true;
      this.errors = {};
      const user = {};

      Object.keys(this.vUser).forEach(key => {
        if(!['', null, undefined].includes(this.vUser[key])){
          user[key] = this.vUser[key];
        }
      });

      if(!['', null, undefined].includes(user.firstname)) {
        if(['', null, undefined].includes(user.lastname)) {
          user.lastname = '-';
        }

        //this.payment = this.paymentMethods[0];
        console.log(this.payment)
        this.confirm({ 
          user: user, 
          comment: this.comment,
          payment: this.payment.value
        }).then(() => {
          this.$router.replace({name: 'sayl-oat-checkout.confirm'});
        }).catch((error) => {
          this.loading = false;
          this.$notification({
            title: this.$t('sayl-oat.error_confirm_title'),
            message: this.$t('sayl-oat.error_confirm_description'),
            type: 'error'
          });
          console.log(error)
        });
      } else {
        this.errors['user'] = [this.$t('sayl-oat.error_username_required')];
        this.loading = false;
      }
    },
  },

  mounted() {
    this.loading = true;
    
    if(this.cart.items.length === 0) {
      this.$router.push({name: 'sayl-oat-catalog.catalog'});
    } else {
      this.checkout().then((order) => { 
        this.getPaymentMethods({orderId: order.id, cashOnly: true}).then((paymentMethods) => {
          if(this.user.contact_email !== null) {
            this.vUser.email = this.user.contact_email;
          } 

          this.loading = false;
          this.payment = this.methods[0];
        }).catch((err) => {
          console.error(err);
        })
      }).catch((err) => {
        console.error(err);
      })
    }
  }
}
</script>
